import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizDatasource,
  WizHgroup,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ColDef } from 'ag-grid-community';
import { ScenSpotRenderer } from './scen-spot.renderer';
import { WizColDef } from '../../../../../manager/workingdata/fei.engine';
import { ScenarioVO } from '../../../../../vo/scenarii/scenario.vo';
import { Model } from '../../../../../model/model';
import { IWidgetFilter } from '../../../../../manager/widgets/i-widget';
import { filterPopData } from './pivot-filter-extended.pop';


@Component({
  // filtre de Grid
  selector: 'pivot-scen-extended-pop',
  templateUrl: './pivot-scen-extended.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotScenExtendedPop extends WizBasePopUp {
  // @ViewChild('liPop', { read: MultiDisplay }) liPop: MultiDisplay<PivotFilterEntryObj>; // liste des valeurs de filtre
  @ViewChild('agGrid') agGrid: WizAgGrid<ScenarioVO>;
  @ViewChild('popFilter', { read: FilterComponent, static: false }) popFilter: FilterComponent; // zone du filtre... du filtre
  @ViewChild('gpOperator') gpOperator: WizHgroup; // zone de comparateur pour champs numériques


  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  // dimensions demandées
  public static width: string = '450px';
  public static height: string = '350px';

  // rendu petite boule pour les scenars
  public renderers: any = {
    scenRenderer: ScenSpotRenderer
  };

  public columns: ColDef[]; // Colonnes du grid
  private model: Model;
  public filter: IWidgetFilter; // la data manipulée

  private doSaveFlag: boolean = true; // valider sur fermeture
  private hasChange: boolean = false; // une modif sur la collection

 
  /** Data source de l'arbre des scenarii */
  public scenDS: WizDatasource<ScenarioVO> = new WizDatasource<ScenarioVO>([])
    .setItemCodeField('code')
    .setSelectionMode('multiple')
    .build();

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    let popDatas: filterPopData = this.datas;
    this.filter = popDatas.filter;
    this.model = this.filter.widget.model;
    this.callback = popDatas.callback;

    this.feedDatasources();
    this.addListeners();
  }


  /**
   * Synchronisation du selected
   * @param pEvent wizEvent contenant l'item sélectionné
   */
  private innerSelectionChange(pEvent: WizEvent): void {
    this.hasChange = true;
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    
    this.popFilter.configure(['code', 'trsLabel'], null, null);
    this.columns = this.buildColumns(); // générer les colonnes depuis le contexte
    
    // mais on va travailler avec des scenars
    this.scenDS.setSource(this.model.scenarioEngine.getScenarioByVisionOrderer(this.model.visionCode));
    this.scenDS.setFilter(this.valFilterFunc.bind(this));

    let selectedScen: ScenarioVO[] = [];
    this.scenDS.getWorkedSource().forEach(scen => {
      if(this.filter.values?.has(scen.code)) {
        selectedScen.push(scen);
      }
    })
    this.scenDS.select(selectedScen);

  }

  /** construction de la colonne */
  private buildColumns(): WizColDef[] {
    const result: WizColDef[] = [];
    let col: WizColDef;

    // colonne de rendu des couleurs de scenarii
    col = {};
    col.headerName = '$.feature.static.SCENARIO.$';
    col.field = 'id';
    col.sortable = false;
    col.resizable = false;
    col.flex = 1;
    col.cellRenderer = 'scenRenderer';
    result.push(col);

    return result
  }

  /**
   * Fonction de filtre des scenarii
   * @param item Elément de la liste testé
   */
  private valFilterFunc(item: any): boolean { 
    return this.popFilter.checkVisible(item);
  }

  /**
   * Refresh du filtre language
   * @param event : Evenement de changement dans la zone de filtre
   */
  private refreshFilter(event: WizEvent = null): void {
    this.scenDS.refresh();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // Filtres
    WizEventManager.addListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.innerSelectionChange);
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.refreshFilter);

  }

  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  public onHide() {
    WizEventManager.removeListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER);

    if (this.doSaveFlag && this.hasChange) {
      let selectedSet: Set<string> = new Set(this.scenDS.selectedItems.map(scen => scen.code));
      this.filter.values = selectedSet;
      this.callback(this.filter);
    }
  }
}
